// extracted by mini-css-extract-plugin
export default {"bnWidgedHorizontal":"bnovo_bnWidgedHorizontal__owjSM","bnWidgedVertical":"bnovo_bnWidgedVertical__GbBau","bnWidgedVertical2":"bnovo_bnWidgedVertical2__2Qn3L"};